import Reveal from "@/components/Reveal";
import { reviews, googleRating } from "@/data/reviews";
import { Star, Quote } from "lucide-react";

export default function Recensioni() {
    return (
        <section
            id="recensioni"
            data-testid="section-recensioni"
            className="relative bg-ink-800 py-28 lg:py-36"
        >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
                <Reveal>
                    <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
                        <div className="max-w-2xl">
                            <p className="text-xs uppercase tracking-widest text-brass">
                                Recensioni — 04
                            </p>
                            <h2
                                data-testid="recensioni-title"
                                className="mt-6 font-serif font-light text-cream text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
                            >
                                La parola
                                <span className="italic text-brass"> ai clienti</span>
                                .
                            </h2>
                        </div>

                        <div
                            data-testid="recensioni-rating"
                            className="flex items-center gap-4 border border-brass/30 px-6 py-4"
                        >
                            <div className="flex items-center gap-1">
                                {[...Array(5)].map((_, i) => (
                                    <Star
                                        key={i}
                                        size={18}
                                        className="text-brass fill-brass"
                                    />
                                ))}
                            </div>
                            <div className="border-l border-white/10 pl-4">
                                <p className="font-serif text-3xl text-cream leading-none">
                                    {googleRating.average.toFixed(1).replace(".", ",")}
                                </p>
                                <p className="text-[10px] uppercase tracking-widest text-cream/50 mt-1">
                                    Google · {googleRating.count} recensioni
                                </p>
                            </div>
                        </div>
                    </div>
                </Reveal>

                <div
                    data-testid="recensioni-grid"
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/5"
                >
                    {reviews.map((r, i) => (
                        <Reveal key={r.id} delay={Math.min(i * 60, 360)}>
                            <article
                                data-testid={`recensione-${r.id}`}
                                className="group bg-ink-900 hover:bg-ink-700 transition-colors duration-700 p-8 lg:p-10 h-full flex flex-col"
                            >
                                <Quote
                                    size={28}
                                    strokeWidth={1}
                                    className="text-brass mb-6"
                                />
                                <p className="text-cream/85 text-base leading-relaxed italic font-serif flex-1">
                                    {r.text}
                                </p>
                                <div className="mt-8 pt-6 border-t border-white/5 flex items-center justify-between gap-4">
                                    <div>
                                        <p className="text-sm text-cream flex items-center gap-2">
                                            {r.author}
                                            {r.badge && (
                                                <span className="text-[9px] uppercase tracking-widest text-brass border border-brass/40 px-1.5 py-0.5">
                                                    {r.badge}
                                                </span>
                                            )}
                                        </p>
                                        <p className="text-xs text-cream/50 mt-1">
                                            {r.date}
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-0.5">
                                        {[...Array(r.rating)].map((_, idx) => (
                                            <Star
                                                key={idx}
                                                size={12}
                                                className="text-brass fill-brass"
                                            />
                                        ))}
                                    </div>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>

                <div className="mt-14 flex justify-center">
                    <a
                        href={googleRating.profileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="recensioni-google-link"
                        className="group inline-flex items-center gap-3 border border-brass/40 hover:bg-brass hover:text-ink-900 text-brass px-8 py-4 text-sm tracking-widest uppercase transition-colors duration-500"
                    >
                        Tutte le {googleRating.count} recensioni su Google
                        <span className="transition-transform duration-500 group-hover:translate-x-1">
                            →
                        </span>
                    </a>
                </div>
            </div>
        </section>
    );
}
